import { darkTheme } from "@rainbow-me/rainbowkit";


export const rainbowTheme = darkTheme({
  accentColorForeground: "white",
});
